module.exports = "<h3>Visão geral do Webview</h3>\r\n<iframe src=\"https://player.vimeo.com/video/271145068\" width=\"1024\" height=\"600\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\r\n<div fxLayoutAlign=\"end center\">\r\n\t<button mat-button (click)=\"dialogRef.close()\">FECHAR</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/video-dialog/video-dialog.component.html
// module id = ./src/app/shared/components/video-dialog/video-dialog.component.html
// module chunks = main